const LatestEpisode = (episodes = {}, action) =>{
    switch (action.type) {
        case 'LATESTPODCASTITEM':
            return action.payload;
        default:
            return episodes;
    }
}

export default LatestEpisode;